module.exports = __webpack_public_path__ + "static/media/envelope-orange.cdc06ae9.svg";